/**
 * DOCUMENT READY SCRIPT
 */
$(function() {
    /**
     * settings/profile
     */
    var change_avatar = $('.profile-wrapper .change-avatar');
    if (change_avatar.length) {
        var avatar_error = change_avatar.find('.avatar.error');
        avatar_error.hide();
        change_avatar.fileupload({
            url: $(this).data('url'),
            dataType: 'json',
            done: function(e, data) {
                if (data.result.status == 'success') {
                    avatar_error.hide();
                    info(data.result.message);
                    var avatar = $('<img>').attr('src', data.result.avatar);
                    $('.icon-avatar').empty().append(avatar);
                    $('.userPic-current-user')
                        .css('background-image', 'url(' + data.result.avatar + ')')
                        .css('font-size', 0);
                }
                else {
                    avatar_error.text(data.result.error).show();
                }
            }
        });
    }

    /**
     * API Settings
     */
    $('body').on('click', '.button.api-key-reset', function() {
        if (!window.confirm($(this).data('confirm'))) {
            return false;
        }
    })
    ;
});

function copyApiKeyToClipboard() {
    var clipboard = new Clipboard('.button');
    clipboard.on('success', function(e) {
        $('#api_key_copy').addClass('copied');
        setTimeout(
            function() {
                $('.link-animation').removeClass('copied');
            },
            500
        );
        e.clearSelection();
    });

}
